import type { CustomAttributeData } from '@risksmart-app/domain/src/types/common.types';
import type { InsertObligationInternalAuditResultMutation } from '@risksmart-app/web-graphql-client/generated/graphql';
import { InsertObligationInternalAuditResultDocument } from '@risksmart-app/web-graphql-client/generated/graphql';

import { createMutationHook } from '@/utils/hook-factories';

export type InsertObligationInternalAuditResultInput = {
  InternalAuditReportId: string;
  ObligationIds: string[];
  // COI-650: V2 required Rating on this insert; the form schema has always
  // made it mandatory, so the type now matches.
  Rating: number;
  Rationale?: string | null;
  TestDate?: string | null;
  CustomAttributeData?: CustomAttributeData | null;
};

export const useInsertObligationInternalAuditResult = createMutationHook({
  name: 'insertObligationInternalAuditResult',
  isIdempotentCreate: true,
  mutationOptions: (trpc, onSuccess, requestContext) =>
    trpc.frontend.internalAuditResult.insertObligation.mutationOptions({
      onSuccess,
      trpc: { context: requestContext },
    }),
  mapInput: (input: InsertObligationInternalAuditResultInput) => input,
  mapResponse: (result: {
    Ids: string[];
  }): InsertObligationInternalAuditResultMutation => ({
    insertChildObligationInternalAuditResult: {
      __typename: 'InsertChildObligationAssessmentResultOutput',
      Ids: result.Ids,
    },
  }),
  invalidate: (trpc) => [
    trpc.frontend.internalAuditResult.pathKey(),
    trpc.frontend.assessment.internalAuditResultCount.queryKey(),
    // COI-471 parity: Apollo twin also evicts `internal_audit_report`.
    trpc.frontend.internalAuditReport.pathKey(),
  ],
  graphqlDocument: InsertObligationInternalAuditResultDocument,
  graphqlVariables: (input: InsertObligationInternalAuditResultInput) => ({
    ...input,
  }),
  evictFields: [
    'obligation_internal_audit_result',
    'internal_audit_report',
    'obligation_internal_audit_result_aggregate',
  ],
});
